import { notification } from 'antd';
import { useState } from 'react';

const KEY_DOING = 'catalog-res-doing';

export const useCatalogStatus = () => {
  const [loading, setLoading] = useState(false);
  return {
    loading,
    start: () => {
      setLoading(true);
      notification.info({ key: KEY_DOING, message: '操作中，请稍候' });
    },
    stop: () => {
      nx.$event.emit('catalog:resource:refresh', () => {
        notification.close(KEY_DOING);
        setTimeout(() => {
          setLoading(false);
          notification.success({ message: '操作成功~', duration: 2 });
        }, 200);
      });
    },
  };
};
